// src/pages/WhyCallistus.js 
// (Assuming this file contains your WhyCallistus component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; // Importing the Navbar component
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';
import Footer from '../../CommonComponent/Footer/footer';

//Page Component
import WhyUS_PageSection from './PageComponent/WhyUS_PageSection'


function WhyCallistus() {

  // The useMeta hook call is removed and its content is moved into <Helmet>
  return (
    <>
      <Helmet>
        {/* Primary SEO Tags */}
        <title>Why Marvel | Marvel Blinds</title>
        <meta
          name="description"
          content="Explore why Marvel stands out in entertainment. Discover its unique stories and characters. Join the journey of imagination today!"
        />
        <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/WhyMarvel/`} />

        {/* Open Graph Tags (for Social Media) */}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Why Marvel" />
        <meta
          property="og:description"
          content="Explore why Marvel stands out in entertainment. Discover its unique stories and characters. Join the journey of imagination today!"
        />
        <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/WhyMarvel/`} />
        <meta property="og:site_name" content="Marvel Blinds " />
      </Helmet>

      {/* Rest of your component structure */}
      <div>
        <Navbar />
        <NotificationBar />
        <WhyUS_PageSection />
        <Footer />
      </div>
    </>
  );
}

export default WhyCallistus;